window.WeightWatchersPartner = (function ($, components) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        urls: {
            sendEmailUrl: '/api/sitecore/WeightWatchersVoucher/SendEmail'
        },
        selectors: {
            buttons: {
                generateVoucherButton: '#voucher-generate-code',
                stickyFooterGenerateVoucherButton: '#sticky-footer-generate-code'
            }
        },
        state: {
            isNorthernIrelandMember: false
        },
        func: {
            init: function () {
                self.state.isNorthernIrelandMember = $('#ww-model').data('model')['IsNorthernIrelandMember'];
                self.func.bind();
            },
            bind: function () {
                if (self.state.isNorthernIrelandMember) {
                    $(self.selectors.buttons.generateVoucherButton).on('click', self.func.sendEmailToNorthernIrelandMember);
                    $(self.selectors.buttons.stickyFooterGenerateVoucherButton).on('click', self.func.sendEmailToNorthernIrelandMember);
                }
            },
            sendEmailToNorthernIrelandMember: function (event) {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                $.ajax({
                    type: 'POST',
                    url: self.urls.sendEmailUrl,
                    data: {},
                    success: function (data) {
                        if (data.emailWasSuccessful){
                            self.func.handleEmailSuccess();
                        } else {
                            self.func.handleEmailFailure();
                        }
                    },
                    error: function () {
                        self.func.handleEmailFailure();
                    }
                });
            },
            handleEmailSuccess: function () {
                window.openModal('ww-email-success-modal');
            },
            handleEmailFailure: function () {
                window.openModal('ww-email-failure-modal');
            }
        }
    };

    return {
        init: self.func.init
    };
})(window.jQuery, { ComplianceInformation: window.ComplianceInformation, Utilities: window.Utilities });

$('document').ready(function () {
    if (window.Utilities.func.isPartnerSignupPage('WeightWatchers')) {
        window.WeightWatchersPartner.init();
    }
});
